import React from 'react';
import Sidebar from '../../components/navigation/Sidebar';
import NotificationCenter from '../../components/navigation/NotificationCenter';
import QuickActionMenu from '../../components/navigation/QuickActionMenu';
import ContactSubmissionManagement from '../admin-dashboard/components/ContactSubmissionManagement';
import Icon from '../../components/AppIcon';
import Toaster from '../../components/Toaster';
import TwoFAReminderBanner from '../../components/TwoFAReminderBanner';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

const AdminComplaints = () => {
  const navigate = useNavigate();
  const { signOut } = useAuth();

  return (
    <div className="min-h-screen bg-background">
      <Toaster position="top-center" />
      <TwoFAReminderBanner />
      <Sidebar userRole="admin" />
      <QuickActionMenu userRole="admin" />
      <div className="lg:ml-60 min-h-screen">
        <header className="sticky top-0 z-40 bg-card border-b border-border">
          <div className="flex items-center justify-between px-4 md:px-6 lg:px-8 py-4">
            <div className="flex items-center gap-4">
              <button
                onClick={() => {
                  const isCollapsed = document.body.classList.toggle('sidebar-collapsed');
                  localStorage.setItem('sidebarCollapsed', isCollapsed.toString());
                }}
                className="p-2 hover:bg-muted rounded-lg transition-colors"
                aria-label="Toggle sidebar"
              >
                <Icon name="PanelLeft" size={24} />
              </button>
              <div>
                <h1 className="text-2xl md:text-3xl font-semibold text-foreground">
                  Complaints
                </h1>
                <p className="text-sm text-muted-foreground mt-1">
                  Contact form submissions &amp; support requests
                </p>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <NotificationCenter userRole="admin" />
              <div className="hidden md:flex items-center gap-3 pl-3 border-l border-border">
                <div className="text-right">
                  <p className="text-sm font-medium text-foreground">Admin User</p>
                  <p className="text-xs text-muted-foreground">System Administrator</p>
                </div>
                <div className="w-10 h-10 rounded-full bg-primary flex items-center justify-center">
                  <Icon name="Shield" size={20} color="#FFFFFF" />
                </div>
                <button
                  onClick={async () => { await signOut(); navigate('/login'); }}
                  className="flex items-center gap-2 px-3 py-2 text-sm text-muted-foreground hover:text-foreground border border-border rounded-lg hover:bg-muted transition-colors"
                >
                  <Icon name="LogOut" size={16} />
                  Logout
                </button>
              </div>
            </div>
          </div>
        </header>

        <main className="px-4 md:px-6 lg:px-8 py-8">
          <ContactSubmissionManagement />
        </main>
      </div>
    </div>
  );
};

export default AdminComplaints;
